import { render, staticRenderFns } from "./HealthDetectionDetail.vue?vue&type=template&id=96c95c22&scoped=true"
import script from "./HealthDetectionDetail.vue?vue&type=script&lang=js"
export * from "./HealthDetectionDetail.vue?vue&type=script&lang=js"
import style0 from "./HealthDetectionDetail.vue?vue&type=style&index=0&id=96c95c22&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96c95c22",
  null
  
)

export default component.exports